export default __webpack_public_path__ + "static/media/compliance-2025.3efae549.jpg";